export * from './lib/assign-grade-to-val-addition';
